import { Component, computed, inject, OnDestroy, OnInit, Signal } from '@angular/core';

import { ProfilePageComponent } from '../../../../../../libs/components/profile/profile-page/profile-page.component';
import { IUser } from '@lb/api/mylb/interfaces';
import { LoaderComponent } from '@lb/components/loader/loader.component';
import { ActivatedRoute } from '@angular/router';
import { LearnerUserStateService } from '../../shared/state/learner-users-state.service';
import { AccountStateService } from '@lb/state/account-state.service';

@Component({
	selector: 'lrnr-learner-profile',
	standalone: true,
	imports: [ProfilePageComponent, LoaderComponent],
	templateUrl: './learner-profile.component.html',
	styleUrl: './learner-profile.component.scss'
})
export class LearnerProfileComponent implements OnInit, OnDestroy {
	private _activatedRoute = inject(ActivatedRoute);
	private _accountStateService = inject(AccountStateService);
	private _learnerUsersStateService = inject(LearnerUserStateService);

	private _loggedInUser = this._accountStateService.user;
	private _allLearners = this._learnerUsersStateService.learners;

	public profile = this._learnerUsersStateService.activeLearnerUser;
	public profileLoading: Signal<boolean> = computed(() => {
		const userLoading = this._learnerUsersStateService.activeUserLoading();
		const learnersLoading = this._learnerUsersStateService.learnersLoading();

		return userLoading || learnersLoading;
	});
	public profileUpdating: Signal<boolean> = this._learnerUsersStateService.activeUserUpdating;

	ngOnInit(): void {
		this._activatedRoute.queryParamMap.subscribe((params) => {
			const isCurrentUser = params.get('isCurrentUser');

			if (isCurrentUser) {
				this._learnerUsersStateService.setActiveLearnerUser(this._loggedInUser());
			}
		});
	}

	ngOnDestroy(): void {
		if (this._loggedInUser().userID === this.profile()?.userID) {
			this._learnerUsersStateService.loadActiveLearnerUser(this._allLearners()[0].learnerUserID, false);
		}
	}

	onCancel(): void {
		this._learnerUsersStateService.setActiveLearnerUser(this.profile());
	}

	onSave(updatedUser: IUser): void {
		this._learnerUsersStateService.updateActiveLearnerUser(updatedUser, true);
	}
}
